module.exports = __webpack_public_path__ + "static/media/frame_50.1360bc5f.jpg";